/**
 * @generated SignedSource<<76bc20c4c12b66aed4cf45037bab3cb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateCell_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditor_package">;
  readonly " $fragmentType": "RoomRatesTableRateCell_package";
};
export type RoomRatesTableRateCell_package$key = {
  readonly " $data"?: RoomRatesTableRateCell_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCell_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateCell_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateEditor_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "5408eb06f42ebe16e81b3c2f2a5487cd";

export default node;
